import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  registerKeys,
} from '@core/react-query/features/registers/registers/register'
import { registersKeys } from '@core/react-query/features/registers/registers'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useEditRegister = (
  options?: UseMutationOptions<
    any,
    RequestErrorType,
    RequestTypes['editRegister']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...registerKeys.editRegister,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(
        registerKeys.details({ registerId: data.id }),
      )
      queryClient.invalidateQueries(registersKeys.registers._def)
    },
  })
}
